<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your <span v-if="showYourPartnerTab">partner's</span> current super</span>

          <ul class="tabs tabs-partner" v-if="includePartner">
            <li class="tabs-title" :class="{ 'is-active': !showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: false })">You</a>
            </li>
            <li class="tabs-title" :class="{ 'is-active': showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: true })">Your partner</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <section>
      <div class="tabs-content">
        <div class="tabs-panel" :class="{ 'is-active': !showYourPartnerTab || !includePartner }">
          <balance-inputs></balance-inputs>
        </div>

        <div class="tabs-panel" :class="{ 'is-active': showYourPartnerTab }" v-if="includePartner">
          <balance-inputs :modifier="partnerModifier"></balance-inputs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants } from '@/constants';

export default {
  components: {
    /* eslint-disable global-require */
    BalanceInputs: require('../../inputs/BalanceInputs').default,
    /* eslint-enable global-require */
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
    };
  },
  computed: {
    ...mapState(['inputs', 'ui']),
    showYourPartnerTab() {
      return this.ui.showYourPartnerTab.value;
    },
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
  },
  methods: {
    ...mapActions([
      'actionShowYourPartnerTab',
    ]),
  },
};
</script>l
